import React from "react";
import { NumericFormat } from "react-number-format";
import "devextreme/data/odata/store";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
import { MAX_COST, MIN_COST } from "../../constants";

class MonthTotals extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      monthname: props.monthname,
      net: this.props.net ? this.props.net : 0,
      technical_cost: this.props.technical_cost ? this.props.technical_cost : 0,
      fee_calculated: 0,
      final_cost: this.props.final_cost ? this.props.final_cost : 0,
      units: this.props.units ? this.props.units : 0,
      thousandSeparator: ",",
      decimalSeparator: ".",
    };
  }

  componentDidMount() {
    var l_thousandSeparator =
      navigator.language.indexOf("fr") > -1
        ? " "
        : navigator.language.indexOf("en-US") > -1
        ? ","
        : navigator.language.indexOf("de-DE") > -1
        ? "."
        : ",";
    var l_decimalSeparator =
      navigator.language.indexOf("fr") > -1
        ? ","
        : navigator.language.indexOf("en-US") > -1
        ? "."
        : navigator.language.indexOf("de-DE") > -1
        ? ","
        : ".";

    this.setState({
      thousandSeparator: l_thousandSeparator,
      decimalSeparator: l_decimalSeparator,
    });
  }
  componentDidUpdate() {
    var net_new = this.props.net;

    if (
      (!isNaN(this.state.net) && this.state.net != net_new) ||
      (isNaN(this.state.net) && !isNaN(net_new))
    ) {
      this.setState({ net: net_new });
    }

    var technical_cost_new = this.props.technical_cost;
    if (
      (!isNaN(this.state.technical_cost) &&
        this.state.technical_cost != technical_cost_new) ||
      (isNaN(this.state.technical_cost) && !isNaN(technical_cost_new))
    ) {
      this.setState({ technical_cost: technical_cost_new });
    }
    var final_cost_new = this.props.final_cost;
    if (
      (!isNaN(this.state.final_cost) &&
        this.state.final_cost != final_cost_new) ||
      (isNaN(this.state.final_cost) && !isNaN(final_cost_new))
    ) {
      this.setState({ final_cost: final_cost_new });
    }

    var fee_calculated_new = this.props.fee_calculated;
    if (
      (!isNaN(this.state.fee_calculated) &&
        this.state.fee_calculated != fee_calculated_new) ||
      (isNaN(this.state.fee_calculated) && !isNaN(fee_calculated_new))
    ) {
      this.setState({ fee_calculated: fee_calculated_new });
    }
    var showUnitPositionSampling_new = this.props.showUnitPositionSampling;
    if (this.state.showUnitPositionSampling != showUnitPositionSampling_new) {
      this.setState({ showUnitPositionSampling: showUnitPositionSampling_new });
    }

    var units_new = this.props.units;
    if (
      (!isNaN(this.state.units) && this.state.units != units_new) ||
      (isNaN(this.state.fee_calculated) && !isNaN(fee_calculated_new))
    ) {
      this.setState({ units: units_new });
    }
  }

  render() {
    return (
      <div className="div-monthly-setup-container_month">
        <div className="div-monthly-setup-container-header">
          <div className="div-monthly-setup-container-cell div-monthly-setup-container-col1">
            <label className="form-label">{this.state.monthname}</label>
          </div>
          <div className="div-monthly-setup-container-cell div-monthly-setup-container-cell div-monthly-setup-container-col2">
            <NumericFormat
              thousandSeparator={this.state.thousandSeparator}
              decimalSeparator={this.state.decimalSeparator}
              ref="net"
              value={this.state.net}
              className="budgetTextBox"
              decimalScale={2}
              disabled={true}
              isAllowed={(values) => {
                const { floatValue } = values;
                return floatValue >= MIN_COST && floatValue <= MAX_COST;
              }}
            />
          </div>
          <div className="div-monthly-setup-container-cell div-monthly-setup-container-col3">
            <NumericFormat
              thousandSeparator={this.state.thousandSeparator}
              decimalSeparator={this.state.decimalSeparator}
              ref="technical_cost"
              value={this.state.technical_cost}
              className="budgetTextBox"
              decimalScale={2}
              disabled={true}
              readOnly={true}
              isAllowed={(values) => {
                const { floatValue } = values;
                return floatValue >= MIN_COST && floatValue <= MAX_COST;
              }}
            />
          </div>
          <div
            className="div-monthly-setup-container-cell div-monthly-setup-container-col4 budget-total"
          ></div>
          <div className="div-monthly-setup-container-cell div-monthly-setup-container-col5"></div>
          <div className="div-monthly-setup-container-cell div-monthly-setup-container-col6">
            <NumericFormat
              thousandSeparator={this.state.thousandSeparator}
              decimalSeparator={this.state.decimalSeparator}
              ref="fee_calculated"
              valueIsNumericString= {true}
              value={
                this.state.fee_calculated != ""
                  ? parseFloat(this.state.fee_calculated).toFixed(2)
                  : ""
              }
              className="budgetTextBox"
              decimalScale={2}
              disabled={true}
              readOnly={true}
              isAllowed={(values) => {
                const { floatValue } = values;
                return floatValue >= MIN_COST && floatValue <= MAX_COST;
              }}
            />
          </div>
          <div className="div-monthly-setup-container-cell div-monthly-setup-container-col7">
            <NumericFormat
              thousandSeparator={this.state.thousandSeparator}
              decimalSeparator={this.state.decimalSeparator}
              valueIsNumericString= {true}
              ref="final_cost"
              value={
                this.state.final_cost != 0
                  ? parseFloat(this.state.final_cost).toFixed(2)
                  : ""
              }
              className="budgetTextBox"
              decimalScale={2}
              disabled={true}
              readOnly={true}
              isAllowed={(values) => {
                const { floatValue } = values;
                return floatValue >= MIN_COST && floatValue <= MAX_COST;
              }}
            />
          </div>
          <div
            className={
              this.state.showUnitPositionSampling
                ? "div-monthly-setup-container-cell div-monthly-setup-container-col8 "
                : "div-monthly-setup-container-cell div-monthly-setup-container-col8 hidden"
            }
          >
            <NumericFormat
              thousandSeparator={this.state.thousandSeparator}
              decimalSeparator={this.state.decimalSeparator}
              ref="units"
              value={this.state.units}
              className="budgetTextBox"
              decimalScale={2}
              disabled={true}
              readOnly={true}
              isAllowed={(values) => {
                const { floatValue } = values;
                return floatValue >= 0 && floatValue <= MAX_COST;
              }}
            />
          </div>
          <div
            className={
              this.state.showUnitPositionSampling
                ? "div-monthly-setup-container-cell div-monthly-setup-container-col9 "
                : "div-monthly-setup-container-cell div-monthly-setup-container-col9 hidden"
            }
          ></div>
          <div
            className={
              this.state.showUnitPositionSampling
                ? "div-monthly-setup-container-cell div-monthly-setup-container-col10 "
                : "div-monthly-setup-container-cell div-monthly-setup-container-col10 hidden"
            }
          ></div>
        </div>
      </div>
    );
  }
}

export default MonthTotals;
